/**
 * Couleur d'accent admin (#RRGGBB) pour l'en-tête de carte brique.
 */
export function isValidHexColor(value) {
  return typeof value === "string" && /^#[0-9A-Fa-f]{6}$/.test(value.trim());
}

/** Texte lisible sur un fond hex plein (clair → texte foncé, foncé → blanc). */
export function getContrastTextOnHex(hex) {
  if (!isValidHexColor(hex)) return "#212529";
  const h = hex.trim();
  const r = parseInt(h.slice(1, 3), 16) / 255;
  const g = parseInt(h.slice(3, 5), 16) / 255;
  const b = parseInt(h.slice(5, 7), 16) / 255;
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;
  return luminance > 0.55 ? "#1a1a1a" : "#ffffff";
}

/** Styles pour Card.Header : fond = couleur accent. */
export function getBriqueAccentHeaderBarStyle(accentColor) {
  if (!isValidHexColor(accentColor)) return null;
  const bg = accentColor.trim();
  const fg = getContrastTextOnHex(bg);
  return {
    backgroundColor: bg,
    color: fg,
    borderBottom: "1px solid rgba(0, 0, 0, 0.08)",
  };
}

/**
 * Variantes Bootstrap pour les boutons « + Forfait / + Groupe / + Produit »
 * dans l’éditeur de brique.
 */
export const BRIQUE_TYPE_ACCENT = {
  forfait: {
    btnActive: "primary",
    btnInactive: "outline-primary",
  },
  group: {
    btnActive: "info",
    btnInactive: "outline-info",
  },
  product: {
    btnActive: "success",
    btnInactive: "outline-success",
  },
};
